import { InitializeMoralRiskStudyCommand } from '../commands';
import { DateOfBirth } from '../models';

export const moralRiskStudyToBackModel = (dateOfBirth: Date): InitializeMoralRiskStudyCommand => {
  return {
    dateOfBirth: new DateOfBirth(dateOfBirth.valueOf()),
  };
};
